export default __webpack_public_path__ + "static/media/form-company.3eecfe15.png";